import HttpClient from "@api/clients/httpClient";
import { Filter } from "@api/models/HttpClientModels";
import City from "../models/City";

const config = {
    endpoint: "cities",
};

export default class CityService {
    httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient(config.endpoint, new Filter());
    }

    findAsync = async () => {
        return await this.httpClient.findAsync<City[]>({}, {}, {}, {});
    }
}